<template>
    <span>
        <span v-show="enabled">
            <span  class="layuicheck">
                 <slot></slot>
            </span>
        </span>
        <span v-show="!enabled">
            <span class="layuicheck-disabled">
            </span>
        </span>
    </span>
</template>

<script>

export default {
    name: 'LayuiCheck',
    props: {
        requestUniqueId: {
            type: String, // // 请求唯一标识，必须有
            default: () => {
                return 'layui-check-' + window.uuid();
            },
        },
        enabled: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
        _model: {
            default: null,
            required: false
        },
        initValue: {
            type: String,
            required: false,
            default: ''
        },
        textField: {
            default: "text",
            type: String
        },
        valueField: {
            default: "value",
            type: String
        },
        skin: {
            default: 'primary',
            type: String
        },
         // 配置了 tableName 那么slot插槽就不起作用
        tableName: {
            type: String,
            default: ''
        },
        queryCondition: {
            type: Object,
            default: () => {
                return {};
            }
        },
        showNullOption : {
            type: Boolean,
            default: false
        },
        selectFields: {
            type: String,
            default: '',        
        },
        sort: {
            type: Array,
            default: () => {
                return []
            }
        },
        initData: {
            type: Array,
            default: () => {
                return []
            }
        },
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data () {
        return {
            id : null,
            el : null,
            isloaded: false,
            selectData: null, //当前选中的值
            data: []
        }
    },
    methods: {
        getData() {
            return this.data;
        },
        getSelectData() {
            return this.selectData;
        },
        setData(data) {
            this.data = data;
        },
        getDataByValue(value) {
           var result = [];
           var valArr = value.split(",");
           for(var i = 0 ; i < this.data.length; i++) {
              var item = this.data[i];
              for(var j = 0 ; j < valArr.length; j++) {
                  if(item[this.valueField] == valArr[j]){
                      result.push(item);
                  }
              } 
           }
           return result;
        },
        // 根据给定的记录，选中select
        // 该方法不应该，也不会修改v-model绑定的值
        select(value) {
            // null 作为空值来处理，防止报错
            if (value == null) {
                value = '';
            }
            this.selectData = this.getDataByValue(value);
            if(!this.ui_update) {
                this.addCheckClass(this.check, value);
                this.addCheckClass(this.disabledCheck, value);
            }
            this.ui_update = false;
        },
        addCheckClass(checkEl, value){
            var allCheck = checkEl.find('.layui-unselect');
            allCheck.removeClass('layui-form-checked');
            allCheck.removeClass('editRow');
            checkEl.find('input').prop("checked", false);
            if (value) {
                var arr = value.split(',');
                for (let i = 0 ; i < arr.length ; i++) {
                    var tmp = arr[i];
                    checkEl.find('input[value="' + tmp + '"]').prop("checked", true);
                    var next = checkEl.find('input[value=' + tmp + ']').next();
                    next.addClass('layui-form-checked').addClass('editRow');
                }
            }
        },
        // 根据最新的data,刷新select
        load() {
            this.check.children().remove();
            this.disabledCheck.children().remove();
            this.data.forEach((item)=> {
                var arr = [];
                arr.push('<input type="checkbox"  lay-skin="' + this.skin + '" name="' + this.id + '" value="' + item[this.valueField] + '" title="' + item[this.textField]);
                arr.push('" lay-filter="' + this.id + '" ');
                arr.push('"  disabled="disabled"  lay-filter="' + this.disabledId + '" ');
                arr.push('/>');
                this.check.append(arr[0] + arr[1] + arr[3]);
                this.disabledCheck.append(arr[0] + arr[2] + arr[3]);
            });
            this.layui.form.render('checkbox', this.id);
            this.layui.form.render('checkbox', this.disabledId);
            this.layui.form.on('checkbox(' + this.id + ')', (data) => {
                this.ui_update = true;
                var selectArr = [];
                if(this._model) {
                    selectArr = this._model.split(",");
                }
                var idx = -1;
                if((idx = selectArr.indexOf(data.value) ) >= 0) {
                    selectArr.splice(idx, 1);
                }else{
                    selectArr.push(data.value);
                }
                var newValue = selectArr.join(",");
                // 通知v-model修改所绑定的值, 该事件会修改this._model的值,以及v-model所绑定的值
                this.$emit('_modelEvent', newValue );
                this.$emit('checkchange', this.getDataByValue(newValue) );
                this.addCheckClass(this.disabledCheck, newValue);
            });
        },
        afterLoad() {
            // 这时组件加载完了，但是可能外部已经修改了model的值，
           // 如果已经修改了，那么就不用执行initValue的逻辑了，因为这个时候initValue的值已经不算是最新的值了
            if(this._model) {
                this.select(this._model);
            } else {
                if(this.initValue) {
                    // 修改v-model绑定的值
                    this.$nextTick(()=> {
                        // 注意$emit这里会触发下面watch监听的_model方法
                        // 是为了给v-model绑定的属性赋值
                        this.$emit('_modelEvent',this.initValue);
                    });
                }
            }
            this.handleEnabled();
        },
         handleEnabled() {
            
        }
    },
    mounted(){
        var element = this.el = $(this.$el);
        var id = this.id = this.uuid();
        this.disabledId = this.id + "_disabled";
        this.check = element.find(".layuicheck");
        this.disabledCheck = element.find(".layuicheck-disabled");
        this.check.attr('lay-filter', id);
        this.disabledCheck.attr('lay-filter', this.disabledId);
        if(this.initData && this.initData.length > 0) {
            this.data = this.initData;
            this.load();
            this.isloaded = true;  
            this.afterLoad();
        } else if(this.tableName) {
            var p2 = this.queryCondition;
            this.api.queryList(
                    this.tableName, 
                    {p2: p2,  p9: this.selectFields, p10: this.sort},
                    this.requestUniqueId
                ).then(response => {
                var results = response.result;
                this.data = results;
                this.load();       
                this.isloaded = true;       
                this.afterLoad();
            });
        } else  {
            var children = this.check.children();
            if(children.length > 0){
                for(var i = 0 ; i < children.length; i++) {
                    var child = $(children[i]);
                    var value = child.attr('value');
                    var text = child.attr('title');
                    var obj = {};
                    obj[this.valueField] = value;
                    obj[this.textField] = text;
                    this.data.push(obj);
                }
                 this.load();  
                 this.isloaded = true;  
                 this.afterLoad();
             }
        }
        
    },
    watch:{
        _model(value){
           if(this.isloaded) {
               this.select(value);
           }
        },
        enabled() {
            if(this.isloaded) {
                this.handleEnabled();
            }
           
        }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/common/LayuiCheck.vue